import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown/with-html';
import clsx from 'clsx';
import raw from 'raw.macro';
import gfm from 'remark-gfm';
import { Container, Navbar, Nav, Row, Col, ListGroup, ListGroupItem, ListGroupItemText, } from 'reactstrap';
import { MainHeader } from 'components/Shared/MainHeader';

const Profile = raw('../../markdowns/Help/Profile.md');
const NewDocument = raw('../../markdowns/Help/NewDocument.md');
const CuestionarioEnPlantilla = raw('../../markdowns/Help/CuestionarioEnPlantilla.md');
const PDFSignature = raw('../../markdowns/Help/PDFSignature.md');
const EnvioOrdenFirmantes = raw('../../markdowns/Help/EnvioOrdenFirmantes.md');
const ContratosMasivosExcel = raw('../../markdowns/Help/ContratosMasivosExcel.md');
const MigrateDocuments = raw('../../markdowns/Help/MigrateDocuments.md');
const Workflow = raw('../../markdowns/Help/Workflow.md');
const DelegarContrato = raw('../../markdowns/Help/DelegarContrato.md');
const LinkedDocuments = raw('../../markdowns/Help/LinkedDocuments.md');
const Comments = raw('../../markdowns/Help/Comments.md');
const MenuLateral = raw('../../markdowns/Help/MenuLateral.md');
const MenuMisContratos = raw('../../markdowns/Help/MenuMisContratos.md');
const CicloVida = raw('../../markdowns/Help/CicloVida.md');
const Anexos = raw('../../markdowns/Help/Anexos.md');
const DocumentoPlantilla = raw('../../markdowns/Help/DocumentoPlantilla.md');
const Blindaje3 = raw('../../markdowns/Help/Blindaje3.md');
const FirmaElectronica = raw('../../markdowns/Help/FirmaElectronica.md');
const FAQ = raw('../../markdowns/Help/FAQ.md');

const index = [
    { label: 'Personalizar', icon: 'user', component: Profile, name: 'profile' },
    { label: 'Documento Nuevo', icon: 'file', component: NewDocument, name: 'new-document' },
    { label: 'Uso de Cuestionario en Plantilla', icon: 'question', component: CuestionarioEnPlantilla, name: 'cuestionario-en-plantilla' },
    { label: 'Envío a firma de PDF', icon: 'file-contract', component: PDFSignature, name: 'pdf-signature' },
    { label: 'Envío con orden de firmantes', icon: 'sort-numeric-down', component: EnvioOrdenFirmantes, name: 'envio-orden-firmantes' },
    { label: 'Generación de contratos masivos', icon: 'file-excel', component: ContratosMasivosExcel, name: 'contratos-masivos-excel' },
    { label: 'Migrar Documentos', icon: 'upload', component: MigrateDocuments, name: 'migrate-documents' },
    { label: 'Workflow', icon: 'code-branch', component: Workflow, name: 'workflow' },
    { label: 'Delegar un contrato', icon: 'share', component: DelegarContrato, name: 'delegar-contrato' },
    { label: 'Documentos vinculados', icon: 'link', component: LinkedDocuments, name: 'linked-documents' },
    { label: 'Comentarios', icon: 'comments', component: Comments, name: 'comments' },
    { label: 'Menú lateral', icon: 'ellipsis-v', component: MenuLateral, name: 'menu-lateral' },
    { label: 'Menú en mis contratos', icon: 'bars', component: MenuMisContratos, name: 'menu-mis-contratos' },
    { label: 'Ciclo de vida', icon: 'project-diagram', component: CicloVida, name: 'ciclo-vida' },
    { label: 'Anexos', icon: 'paperclip', component: Anexos, name: 'anexos' },
    { label: 'Creando un documento de cero', icon: 'file', component: DocumentoPlantilla, name: 'documento-plantilla' },
    { label: 'Blindaje 3', icon: 'shield-alt', component: Blindaje3, name: 'blindaje-3' },
    { label: 'Firma con firma electrónica avanzada', icon: 'signature', component: FirmaElectronica, name: 'firma-electronica' },
    { label: 'Preguntas Frecuentes', icon: 'question-circle', component: FAQ, name: 'faq' }
];

function Help() {

    const topRef = useRef()
    const { t } = useTranslation();
    const [view, setView] = useState('profile');

    const handleSetView = useCallback((val) => {
        setView(val);
    }, []);

    useEffect(() => {
        window.scrollTo({
            behavior: 'smooth',
            top: topRef.current.offsetTop
        });
    }, [view]);

    return (
        <Container fluid className="overflow-hidden h-100">
            <MainHeader title="help.manual">
            </MainHeader>
            <Row className="h-100">
                <Col md="3" sm="12" className="h-100" id="sidebar">
                    <div className="p-3 p-md-1 overflow-auto" style={{ height: 'calc( 100% - 56px)' }}>
                        <ListGroup >
                            {index.map((i) => (
                                <ListGroupItem className="pointer mt-4 text-muted bg-transparent border-0 m-0 p-0" onClick={() => handleSetView(i.name)}>
                                    <ListGroupItemText className="text-muted bg-transparent" >
                                        <i className={clsx('fas', `fa-${i.icon}`)}></i>{' '}
                                        {i.label}
                                    </ListGroupItemText>
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                    </div>
                </Col>
                <Col md="9" className="p-3 overflow-x-hidden overflow-y-auto" style={{ height: 'calc( 100% - 56px)' }} id="content">
                    <div ref={topRef}></div>
                    <ReactMarkdown
                        plugins={[gfm]}
                        source={index.find(i => i.name === view).component}
                        escapeHtml={false}
                    ></ReactMarkdown>
                </Col>
            </Row>

        </Container>
    )
}

export default Help;
